import Axios from "axios";
// import router from "@/router/index.js";
export default {
  async _request(
    method,
    url,
    data,
    contentType = "application/json;charset=UTF-8",
    auth
  ) {
    const user = JSON.parse(localStorage.getItem("token"));
    let headers =
      user && user.accessToken
        ? {
            authorization: user.tokenType + " " + user.accessToken,
            "Content-Type": contentType
          }
        : {
            "Content-Type": contentType
          };
    let urls = "/api/v1" + url;
    if (auth && auth == "area") {
      urls = "/api/area" + url;
    } else if (auth && auth == "reminds") {
      urls = "/api/notify" + url;
    } else {
      urls = "/api/v1" + url;
    }
    const result = await Axios({
      method,
      url: urls,
      headers,
      data,
      params: method === "get" ? data : null
    }).catch(e => {
      return {
        data: {
          errno: e,
          errmsg: "网络错误！无法获取API数据！请检查后台是否已启动"
        }
      };
    });
    return new Promise((resolve, reject) => {
      console.log(result.data.errmsg);
      if (result.data.errno === 0) {
        resolve(result.data.data ? result.data.data : "");
      } else if (!result.status && result.data.errno.response.status === 401) {
        // reject("登录已过期，请重新登录");
        localStorage.removeItem("token");
        // eslint-disable-next-line prefer-promise-reject-errors
        // router.push("/login");
        // reject("登录已过期，请重新登录");
      } else if (
        result.data.errno !== 0 &&
        result.data.errno.response.status === 501
      ) {
        reject(result.data.errno.response.data.errmsg || "绑定失败");
      } else {
        reject(
          result.data.detail && result.data.detail !== ""
            ? result.data.detail || result.data.errmsg
            : ""
        );
      }
    });
  },
  async get(url, data) {
    return this._request("get", url, data);
  },
  async getArea(url, data) {
    return this._request(
      "get",
      url,
      data,
      "application/json;charset=UTF-8",
      "area"
    );
  },
  async getReminds(url, data) {
    return this._request(
      "get",
      url,
      data,
      "application/json;charset=UTF-8",
      "reminds"
    );
  },
  async post(url, data, contentType) {
    return this._request("post", url, data, contentType);
  },
  async put(url, data) {
    return this._request("put", url, data);
  },
  async delete(url, data) {
    return this._request("delete", url, data);
  }
};
